import styled, { keyframes } from 'styled-components';

const gentlePulse = keyframes`
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
`;

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const AiLoaderContainer = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ $compact }) => ($compact ? '0' : '1rem')};
  padding: ${({ $compact }) => ($compact ? '0' : '3rem 1rem')};
  width: 100%;
`;

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  animation: ${gentlePulse} 2.5s ease-in-out infinite;

  & > svg {
    width: 32px;
    height: 32px;
  }
`;

export const MessageText = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
  min-height: 1.5em;
  animation: ${fadeInUp} 0.3s ease-out;
`;
